import { useEffect, useState } from "react";
import { formatRange, pad } from "@/lib/race";
import { useLang } from "@/context/LangContext";

const startOf = (race) => new Date(`${race.date_start}T${race.start_time || "09:00"}:00`).getTime();
const endOf = (race) => new Date(`${race.date_end || race.date_start}T23:59:59`).getTime();

const diff = (race) => {
  const ms = Math.max(0, startOf(race) - Date.now());
  return { d: Math.floor(ms / 864e5), h: Math.floor(ms / 36e5) % 24, m: Math.floor(ms / 6e4) % 60, s: Math.floor(ms / 1e3) % 60, live: ms === 0 && Date.now() <= endOf(race) };
};

export const Countdown = ({ race }) => {
  const { t } = useLang();
  const [time, setTime] = useState(() => (race?.date_start ? diff(race) : null));

  useEffect(() => {
    if (!race?.date_start) return undefined;
    setTime(diff(race));
    const id = setInterval(() => setTime(diff(race)), 1000);
    return () => clearInterval(id);
  }, [race]);

  if (!race) {
    return (
      <div data-testid="next-race-card" className="border border-white/10 bg-ink/60 p-5 backdrop-blur-xl">
        <p className="label-mono text-white">{t.countdown.next}</p>
        <p className="mt-2 font-display text-2xl font-extrabold uppercase">{t.countdown.tba}</p>
      </div>
    );
  }

  return (
    <div data-testid="next-race-card" className="corner-clip w-full border border-white/10 bg-ink/60 p-5 backdrop-blur-xl sm:w-auto sm:min-w-[340px]">
      <div className="flex items-center justify-between gap-6">
        <p className="label-mono flex items-center gap-2 text-volt">
          <span className={`h-1.5 w-1.5 rounded-full blink ${time?.live ? "bg-flag" : "bg-volt"}`} />
          {time?.live ? t.countdown.live : `${t.countdown.next} · ${race.championship === "E4" ? "E4 · " : ""}R${pad(race.round)}`}
        </p>
        <p className="label-mono text-white" data-testid="next-race-dates">{formatRange(race.date_start, race.date_end, t.months)}</p>
      </div>
      <p className="mt-2 font-display text-2xl font-extrabold uppercase text-white" data-testid="next-race-name">{race.circuit}</p>
      <div className="mt-4 grid grid-cols-4 gap-2" data-testid="next-race-countdown">
        {t.countdown.units.map((k, i) => (
          <div key={k} className="border-l border-white/15 pl-3">
            <p className="font-mono text-2xl font-bold tabular-nums text-white">{pad([time?.d, time?.h, time?.m, time?.s][i] ?? 0)}</p>
            <p className="font-mono text-[11px] tracking-widest text-zinc-400">{k}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
